import {
  approvePointUse,
  rejectPointUse,
  cancelPointUse,
} from "@/api/providerDashboard";

export default {
  async handleApprove(transactionId) {
    try {
      await this.$confirm(
        "이 포인트 사용 요청을 승인하시겠습니까? 고객의 포인트가 차감됩니다.",
        "승인 확인",
        {
          confirmButtonText: "승인",
          cancelButtonText: "취소",
          type: "warning",
        }
      );
      this.processingId = transactionId;
      const res = await approvePointUse(transactionId);
      if (res.data.status === 200) {
        this.$message.success("승인되었습니다.");
        this.fetchPending();
        this.fetchHistory();
      } else {
        this.$message.error(res.data.message || "승인에 실패했습니다.");
      }
    } catch (e) {
      if (e !== "cancel") this.$message.error("승인에 실패했습니다.");
    } finally {
      this.processingId = null;
    }
  },
  async handleReject(transactionId) {
    try {
      await this.$confirm(
        "이 포인트 사용 요청을 거절하시겠습니까?",
        "거절 확인",
        {
          confirmButtonText: "거절",
          cancelButtonText: "취소",
          type: "warning",
        }
      );
      this.processingId = transactionId;
      const res = await rejectPointUse(transactionId);
      if (res.data.status === 200) {
        this.$message.success("거절되었습니다.");
        this.fetchPending();
        this.fetchHistory();
      } else {
        this.$message.error(res.data.message || "거절에 실패했습니다.");
      }
    } catch (e) {
      if (e !== "cancel") this.$message.error("거절에 실패했습니다.");
    } finally {
      this.processingId = null;
    }
  },
  async handleCancel(transactionId) {
    try {
      await this.$confirm(
        "이 포인트 사용을 취소하시겠습니까? 고객에게 포인트가 환불됩니다.",
        "취소 확인",
        {
          confirmButtonText: "취소 처리",
          cancelButtonText: "닫기",
          type: "warning",
        }
      );
      this.processingId = transactionId;
      const res = await cancelPointUse(transactionId);
      if (res.data.status === 200) {
        this.$message.success("포인트 사용이 취소되었습니다.");
        this.fetchHistory();
      } else {
        this.$message.error(res.data.message || "취소에 실패했습니다.");
      }
    } catch (e) {
      if (e !== "cancel") this.$message.error("취소에 실패했습니다.");
    } finally {
      this.processingId = null;
    }
  },
};
